<template>
    <div class="bgnothing" v-if="condition">
        <img src="../../assets/images/nothing.png" alt="">
        <p class="bgtext">{{getDis()}}</p>
    </div>
</template>
<script>
export default {
    props: {
        condition: {
            default: false
        },
        dis:{
            default:''
        }
    },
    data() {
        return {

        }
    },
    methods: {
        getDis(){
            if(!this.dis) return this.$t('nothing');
            else return this.dis;
        }
    }
}
</script>
<style lang='less' scoped>
.bgnothing {
    text-align: center;
    margin-top: 4.9333rem;
    img {
        width: 2.6667rem;
    }
    .bgtext {
        text-align: center;
        font-size: 0.3733rem;
        color: #aaa;
        /*background-color: #fff*/
    }
}
</style>



// WEBPACK FOOTER //
// nothing.vue?0c521cc4